export const GUID = {
  fahes: {
    success: {
      feedback: 'ff2456e9-0580-446a-8188-b71048b2ff08'
    },
    footer: {
      en: '006c9585-443f-4763-a8c2-bae50bd3c783',
      ar: '7259c505-bcd2-4ad2-be7e-969b822cf9d5'
    }
  },
  empty: '00000000-0000-0000-0000-000000000000',
  woqod: {
    lookUps: {
      stations: 'f2de471a-c32d-4c41-a95e-1af50f6c73ee'
    },
    header: {
      invstor: '3a20641a-a31f-48c4-890b-b4e997d084d3',
      Fahesinvstor: 'ef2c1c38-6ae0-4ade-b55e-9f235c9a76cf',
      freeNumber: '2dc89866-1b0b-449d-acaa-b8064f48f6a7',
      FahesfreeNumber: '46d6a75c-6051-4592-82ca-a66e16aedc35',
      callCenter: 'f5d0bf80-7f16-4e8b-8d3c-b47c89831e09',
      FahescallCenter: 'a79ede83-05e9-4a6d-810c-fb5b022f09ac',
    },
    lubricant: {
      landing: '8002A772-3C6B-4F86-9A3B-25205314EC5B'
    },
    success: {
      requestETag: '2526a03f-6a79-42b6-8519-48ed7fd36320',
      rentAShop: 'dbdd85c0-fbdd-46af-a7cd-e0a5baf7a4e1',
      becomeASupplier: '268da299-c7e0-435a-92dd-48351d5a3f81',
      feedback: 'a1026b23-d06d-404c-ac27-7527270c17ed',
      jobApply: 'ef7c6535-1506-4827-bf59-7757c0374ab3',
      tenderRequest: '6067c3b7-a545-4449-b133-5b9cbcb890e6',
      tenderAlert: 'c1875b57-9a0f-40b6-bef4-3f595fa84a25',
      companyInformation: '584be4ff-91f4-4ea7-95b9-a20f68bec752',
      payment: '2b99365e-948a-49d6-a6f5-2080379d2629'
    },
    footer: {
      en: '006c9585-443f-4763-a8c2-bae50bd3c783',
      ar: '7259c505-bcd2-4ad2-be7e-969b822cf9d5'
    },
    help: {
      callCenterOffline: '4c602960-05f3-4d01-88f8-69f423936802',
      instagram: '94632cac-8c6b-45b4-98a7-7f18cb47ca62',
      whatsApp: 'a4949670-f1cd-4e0d-9e2e-8ae768d6d617',
      needHelp: '43696387-58be-4a9e-9a0a-70ae7a1fc4a0',
      facebook: '42af1887-07ec-4a0d-a1d4-dfe21be68b27'
    },
    map: {
      Sidra: "e7c1bea7-6d6e-4ba4-a43e-e4c07fdd4eb9",//Sidra
      Petrol_station: "f630af84-c963-4d09-a3c8-c6b54a048e69",//Petrol Station
      electric: "6572e37d-985e-4776-a4c8-d89a7eccc4c3",//electric Station
      marineStation: "828543a3-4c69-48cc-9cb1-43cc39add76b",
      fahes: "d036e414-afcc-43d2-a050-271116244671"
    },
    become_supplier: {
      sidra: '83217095-ce26-4a0d-9948-2ff6e45f57b3',
      auto_care: '57ad8385-31a7-4724-9516-4a6faf148286',
      general: 'c33f977b-dd6f-4928-aa2e-4db0f766746b'
    },
    revampMap: {
      petrolStation: 'f630af84-c963-4d09-a3c8-c6b54a048e69',
      marinePetrolStation: '828543a3-4c69-48cc-9cb1-43cc39add76b',
      sidra: 'e7c1bea7-6d6e-4ba4-a43e-e4c07fdd4eb9',
      fahes: 'd036e414-afcc-43d2-a050-271116244671',
      ev: '6572e37d-985e-4776-a4c8-d89a7eccc4c3',
      cng: '60a27225-b656-4d1b-9a6d-dc9a348f347d',
      defaultAllStationData: {
        key: "all",
        title: {
          en: "PETROL_STATION.All_Stations",
          ar: "PETROL_STATION.All_Stations"
        },
        locationTypeImageID: "assets/images/all-stations.png",
      }
    }
  },
};